<template>
  <div class="footer">
  	<div class="con-box">
  		<div class="foot-item">主办单位：灵武市科学技术局</div>
		<div class="foot-item">单位地址：银川市灵武市东塔镇灵武电商创业园附近（邮编:751400）</div>
  		<div class="foot-item"><span>宁ICP备16001670号</span></div>
  	</div>
  </div>
</template>

<script>
export default {
  name: 'BasicFooter',
}
</script>

<style scoped>
.footer{
	width: 100%;
	padding-bottom: 20px;
	background-color: #0067b8;
}
.con-box{
	padding-top: 20px;
}
.con-box .foot-item{
	font-size: 14px;
	color: #fff;
	line-height: 30px;
}
.con-box .foot-item img{
	vertical-align: middle;
}

</style>